import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendWelcomeEmail } from '../services/emailService';
import { verifyUserToken } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function AccountVerification() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Vérification en cours...');
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('Lien de vérification invalide.');
      return;
    }
    verifyUserToken(token)
      .then((response) => {
        const verifiedUser = response.user || response;
        if (verifiedUser?.email) {
          sendWelcomeEmail(verifiedUser.email);
        }
        refreshUser();
        setStatus('Votre compte est maintenant actif ! Vous pouvez vous connecter.');
      })
      .catch((error) => {
        setStatus(error.message || 'Impossible de vérifier votre compte pour le moment.');
      });
  }, [searchParams]);

  return (
    <section className="account-page">
      <div className="account-page__card">
        <h1>Activation du compte</h1>
        <p>{status}</p>
        <button type="button" className="site-header__cta" onClick={() => navigate('/')}>Retour à l’accueil</button>
      </div>
    </section>
  );
}
